import { canUserAccessModule } from '../../navigation/moduleAccess';

export const readReportUser = () => {
    try {
        const stored = JSON.parse(localStorage.getItem('userDetails') || localStorage.getItem('adminUser') || '{}');
        return stored?.data?.adminUser || {};
    } catch { return {}; }
};
export const canViewBonuses = user => canUserAccessModule(user, 'reports',
    ['admin', 'superAdmin', 'support'].includes(user?.role?.uid || user?.role));
export const statusLabel = value => ({ approved: 'Aprobado', provisional: 'Provisional', pending: 'Pendiente', configuration_error: 'Revisar configuración', submitted: 'Enviado', draft: 'Borrador', rejected: 'Rechazado', missing: 'Sin registro', duplicate: 'Registro duplicado' })[value] || value;
export const routesLabel = row => {
    const names = (row.routes || []).join(', ');
    if (row.routeStatus === 'missing') return 'Sin dato histórico';
    if (row.routeStatus === 'partial') return `${names || 'Sin rutas en los registros disponibles'} (historial parcial)`;
    if (row.routeStatus === 'recorded') return names || 'Sin rutas en los registros OKR';
    if (row.routeStatus === 'future') return 'Sin asignación futura registrada';
    return names || 'Sin ruta asignada';
};

export const bonusSummaryExport = (rows, report) => rows.map(row => {
    const result = { Ciclo: report.cycle.name, Mes: report.month, 'ID operador': row.userId, Operador: row.name,
        [report.routeMode === 'historical' ? 'Rutas del mes' : 'Rutas actuales']: routesLabel(row),
        'Fecha de consulta': report.generatedAt || '', Estado: statusLabel(row.status) };
    row.indicators.forEach(indicator => {
        result[`${indicator.title} (peso %)`] = indicator.weightPercentage;
        result[`${indicator.title} (resultado %)`] = indicator.achievementPercentage ?? 'Pendiente';
    });
    return { ...result, 'Resultado mensual (%)': row.achievementPercentage ?? 'Pendiente', 'Máximo (USD)': row.maximum, 'Bono (USD)': row.bonus ?? 'Pendiente', Observaciones: row.issues.join('; '), 'Asignación mensual': 'Mes de cierre de la semana OKR' };
});
export const bonusDetailExport = (rows, report) => rows.flatMap(row => row.weekly.flatMap(week => week.details.map(indicator => ({
    Ciclo: report.cycle.name, Mes: report.month, 'ID operador': row.userId, Operador: row.name, Semana: week.weekNumber, Desde: week.startDate, Hasta: week.endDate,
    'ID indicador': indicator.keyResultId, Indicador: indicator.title, 'Peso (%)': indicator.weightPercentage, 'ID registro OKR': indicator.entryId || '',
    'Puntos finales OKR': indicator.finalPoints ?? 'Pendiente', 'Puntos semanales posibles': indicator.weeklyBasePoints,
    'Resultado (%)': indicator.achievementPercentage ?? 'Pendiente', Estado: statusLabel(indicator.status), 'Última sincronización': indicator.syncedAt || '',
}))));
